import React, { useEffect, useMemo, useState } from "react";

const ALBUMS = { engagement: "Engagement", proposal: "Proposal", events: "Events", mehndi: "Events", sangeet: "Events", rehearsal: "Events",
  portraits: "Portraits", ceremony: "Wedding day", wedding_day: "Wedding day", reception: "Reception", honeymoon: "Honeymoon" };
export const albumLabel = (p) => ALBUMS[p.album] || "Moments";
export const monthLabel = (p) => new Date(p.created_at).toLocaleDateString(undefined, { month: "short", year: "numeric" });

// Vertical timeline rail for snap feeds: jumps to the first post of a chapter and follows the scroll.
export function TimelineRail({ posts, rootRef, labelOf }) {
  const chapters = useMemo(() => {
    const seen = new Map();
    posts.forEach((p) => { const l = labelOf(p); if (!seen.has(l)) seen.set(l, p.item_id); });
    return [...seen.entries()];
  }, [posts, labelOf]);
  const [cur, setCur] = useState("");
  useEffect(() => {
    const root = rootRef.current;
    if (!root) return undefined;
    const io = new IntersectionObserver((es) => es.forEach((e) => {
      if (e.isIntersecting) { const p = posts.find((x) => `post-${x.item_id}` === e.target.id); p && setCur(labelOf(p)); }
    }), { root, threshold: 0.6 });
    posts.forEach((p) => { const el = document.getElementById(`post-${p.item_id}`); el && io.observe(el); });
    return () => io.disconnect();
  }, [posts, rootRef, labelOf]);
  if (chapters.length < 2) return null;
  return (
    <nav className="absolute left-2 md:left-6 top-1/2 -translate-y-1/2 z-20 flex flex-col gap-1" aria-label="Timeline" data-testid="timeline-rail">
      <span className="absolute left-[7px] top-2 bottom-2 w-px bg-white/25" />
      {chapters.map(([label, id]) => {
        const on = label === cur;
        return (
          <button key={label} onClick={() => document.getElementById(`post-${id}`)?.scrollIntoView({ behavior: "smooth" })}
            className="relative flex items-center gap-2 py-1 text-left group" data-testid={`timeline-${label.toLowerCase().replace(/\s+/g, "-")}`}>
            <span className={`w-[15px] h-[15px] rounded-full border-2 transition-colors ${on ? "bg-[var(--gold)] border-[var(--gold)]" : "bg-black/60 border-white/50"}`} />
            <span className={`text-[10px] uppercase tracking-[0.15em] px-2 py-0.5 rounded-full bg-black/45 backdrop-blur transition-opacity ${on ? "opacity-100 text-[var(--gold)]" : "opacity-0 md:opacity-70 group-hover:opacity-100 text-white"}`}>{label}</span>
          </button>
        );
      })}
    </nav>
  );
}
